import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export { BACKEND_URL };

// Prefix a relative backend path (e.g. /api/images/..) with the backend origin.
// Leaves absolute URLs (http/https) untouched.
export const resolveUrl = (url) => {
  if (!url) return url;
  if (/^https?:\/\//i.test(url)) return url;
  return `${BACKEND_URL}${url.startsWith("/") ? "" : "/"}${url}`;
};

export const api = axios.create({ baseURL: API });

// Attach admin token when present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("krs_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
